import * as mapbox from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import MapboxDirections from "@mapbox/mapbox-gl-directions/dist/mapbox-gl-directions";

const accessToken = document.querySelector("#map").dataset.accessToken;

let map;
let coordinates = [];
let markers = [];
let popups = [];
let directions;

let currentProfile = "mapbox/driving-traffic"; // por defecto
if (typeof window.currentProfile !== 'undefined' && window.currentProfile !== null) {
    currentProfile = window.currentProfile;
}
console.log("currentProfile", currentProfile);
console.log("currentProfile", window.currentProfile);

console.log("map-itinerary.js");

function formatTime(seconds) {
    // console.log("formatTime()");

    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const remainingHours = hours % 24;
    const remainingMinutes = minutes % 60;

    if (days > 0) {
        return `${days}d ${remainingHours}h ${remainingMinutes}m`;
    } else if (remainingHours > 0) {
        return `${remainingHours}h ${remainingMinutes}m`;
    } else {
        return `${remainingMinutes}m`;
    }
}

function initializeMap() {
    console.log("initializeMap()");

    if (map) {
        map.remove();
        map = null;
    }

    const mapContainer = document.getElementById("map");
    if (!mapContainer) {
        return;
    }

    // map = new mapbox.Map({
    //     container: "map",
    //     style: "mapbox://styles/mapbox/streets-v12",
    //     center: [-5.66388, 40.96882],
    //     zoom: 9,
    //     accessToken: accessToken,
    // });

    var initLat = -5.66388;
    var initLng = 40.96882;

    if (typeof window.initLng !== 'undefined' && window.initLng !== null && typeof window.initLat !== 'undefined' && window.initLat !== null) {
        initLat = -window.initLat;
        initLng = window.initLng;
    }
    map = new mapbox.Map({
        container: "map",
        style: "mapbox://styles/mapbox/streets-v12",
        center: [initLat, initLng],
        zoom: 9,
        accessToken: accessToken,
    });

    // map.scrollZoom.disable(); // Deshabilita el zoom con scroll
    // map.boxZoom.disable(); // Deshabilita el zoom con caja
    // map.dragRotate.disable(); // Deshabilita la rotación al arrastrar
    // map.dragPan.disable(); // Deshabilita el arrastre del mapa
    // map.keyboard.disable(); // Deshabilita las interacciones por teclado
    // map.doubleClickZoom.disable(); // Deshabilita el zoom al hacer doble clic
    // map.touchZoomRotate.disable(); // Deshabilita el zoom y la rotación en dispositivos táctiles

    map.addControl(
        new MapboxGeocoder({
            accessToken: accessToken,
            mapboxgl: mapbox,
        })
    );

    // map.on("click", (event) => {
    //     // Do nothing on click
    //     console.log("Map clicked, but no markers will be added.");
    // });

    map.on("load", () => {
        console.log("Mapa cargado");

        console.log(currentProfile);

        //console.log('Mapa cargado');
        initializeDirections(currentProfile);
        addItineraryMarkers();
    });
}

function initializeDirections(profile) {
    console.log("initializeDirections()");
    //console.log('nuevo perfil:', profile);

    // elimina direcciones
    if (directions) {
        //console.log('elimina direcciones>>');
        //map.removeControl(directions);
        directions = null;
    }

    directions = new MapboxDirections({
        accessToken: accessToken,
        unit: "metric",
        profile: profile,
        interactive: false,
        controls: {
            inputs: false,
            instructions: false,
        },
    });

    map.addControl(directions, "top-left");

    directions.on("route", (event) => {
        console.log("Route recieved from DirectionsAPI");
        const route = event.route[0];
        // window.route = route;
        calculateAndDisplayTravelTime(route);

        console.log(route);
        const directionsContainer = document.getElementById("directions");
        directionsContainer.innerHTML = "";

        // Po
        route.legs.forEach((leg, legIndex) => {
            const legElement = document.createElement("div");
            legElement.className = "leg-instructions";
            legElement.innerHTML = `<strong>Ruta ${legIndex + 1
                }</strong> (Tiempo estimado: ${formatTime(leg.duration)})`;

            const midPointIndex = Math.floor(leg.steps.length / 2);
            const midPoint = leg.steps[midPointIndex].maneuver.location;

            // const popup = new mapbox.Popup()
            //     .setLngLat(midPoint)
            //     .setHTML(
            //         `<strong class="routeTimePopup" data-time="${formatTime(
            //             leg.duration
            //         )}">${formatTime(leg.duration)}</strong>`
            //     )
            //     .addTo(map);

            // popups.push(popup);

            // console.log("popups", popups);

            leg.steps.forEach((step) => {
                const stepElement = document.createElement("div");
                stepElement.className = "step-instruction";
                stepElement.textContent = step.maneuver.instruction;
                legElement.appendChild(stepElement);
            });

            directionsContainer.appendChild(legElement);
        });
    });
}

function addItineraryMarkers() {
    // return;
    console.log("addItineraryMarkers()");
    const itineraryItems = document.querySelectorAll(
        "#itineraryList .bodyItemItineraryList"
    );
    const bounds = new mapbox.LngLatBounds();

    coordinates = [];
    markers.forEach((marker) => marker.remove());
    markers = [];
    popups.forEach((popup) => popup.remove());
    popups = [];

    if (directions) {
        console.log("directions", directions);

        const waypoints = directions.getWaypoints();
        console.log("waypoints", waypoints);
        for (let i = waypoints.length - 1; i >= 0; i--) {
            console.log("remove waypoint", i);
            directions.removeWaypoint(i);
        }
    }
    document.getElementById("directions").innerHTML = "";

    itineraryItems.forEach((item, index) => {
        console.log("looping to add markers");
        console.log(item.dataset);
        console.log("index: " + index);

        const longitude = parseFloat(item.dataset.longitude);
        const latitude = parseFloat(item.dataset.latitude);
        const name = item.dataset.name;
        const markerNumber = index + 1;
        console.log("name:");
        console.log(name);

        console.log("coordenadas");
        console.log(longitude);
        console.log(latitude);

        if (!isNaN(longitude) && !isNaN(latitude)) {
            coordinates.push([longitude, latitude]);

            const markerElement = document.createElement("div");
            markerElement.className = "custom-marker";
            markerElement.textContent = markerNumber;

            const marker = new mapbox.Marker(markerElement)
                .setLngLat([longitude, latitude])
                .addTo(map);

            markers.push(marker);

            bounds.extend([longitude, latitude]);

            markerElement.addEventListener("click", () => {
                alert(`Site: ${name}`);
            });
        } else {
            console.log("1.No hay coordenadas para el marcador: " + name);
        }
    });

    if (itineraryItems.length > 0) {
        map.fitBounds(bounds, { padding: 20 });

        if (coordinates.length > 1) {
            directions.setOrigin(coordinates[0]);
            directions.setDestination(coordinates[coordinates.length - 1]);

            coordinates.slice(1, -1).forEach((coord, index) => {
                directions.addWaypoint(index, coord);
            });
        }
    }
}

function getMunicipio(lng, lat) {
    console.log("getMunicipio()");
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?access_token=${accessToken}&types=place`;

    console.log(url);

    fetch(url)
        .then((response) => response.json())
        .then((data) => {
            const features = data.features;
            const municipio = features.find((feature) =>
                feature.place_type.includes("place")
            );

            if (municipio) {
                console.log(municipio.text); // Imprime el nombre del municipio
                return municipio.text;
            } else {
                console.log(null); // No se encontró un municipio
                return null;
            }
        })
        .catch((error) => {
            console.error("Error al obtener el municipio:", error);
            return false;
        });

    //return "no";
}

/*
function getMunicipio(lng, lat)
 {
    const geocoder = new MapboxGeocoder({
        accessToken: accessToken,
        types: 'place',
        reverseGeocode: true,
        mapboxgl: mapbox
    });

    console.log("1");

    const query = `${lng},${lat}`;
    console.log(query);
    geocoder.query(query);

    console.log("2");

    // Escucha el evento "result" para manejar la respuesta de geocodificación
    geocoder.on('result', function(e) {
        const features = e.result.features;

        // Encuentra la característica del lugar que contiene el municipio
        const municipio = features.find(function(feature) {
            return feature.place_type.includes("place");
        });

        // Devuelve el nombre del municipio si existe, de lo contrario, null
        if (municipio) {
            console.log(municipio.text); // Aquí puedes hacer lo que quieras con el nombre del municipio
        } else {
            console.log(null);
        }
    });

    // Manejo de errores en caso de falla en la geocodificación
    geocoder.on('error', function(err) {
        console.error('Error al obtener el municipio:', err);
    });
}
    */

function marcadoresMismoMunicipio() {
    console.log("marcadoresMismoMunicipio()");

    const itineraryItems = document.querySelectorAll(
        "#itineraryList .bodyItemItineraryList"
    );
    const bounds = new mapbox.LngLatBounds();
    var marcadores = Array();
    var municipio;

    console.log(itineraryItems);

    itineraryItems.forEach((item, index) => {
        console.log(item.dataset);
        const longitude = parseFloat(item.dataset.longitude);
        const latitude = parseFloat(item.dataset.latitude);
        const name = item.dataset.name;
        const markerNumber = index + 1;

        let canProceed = true;
        if (!longitude || !latitude) {
            // console.log("2.No hay coordenadas para el marcador: " + name);
            // console.log("Coordenadas: " + longitude + ", " + latitude);
            canProceed = false;
        }

        if (isNaN(longitude) || isNaN(latitude)) {
            console.log(
                "Las coordenadas no son válidas para el marcador: " + name
            );
            console.log("Coordenadas: " + longitude + ", " + latitude);

            canProceed = false;
        }

        if (canProceed) {
            if (!isNaN(longitude) && !isNaN(latitude)) {
                municipio = getMunicipio(longitude, latitude);

                console.log("el municipio es:");
                console.log(municipio);
            }
        }
    });

    console.log("Resultado mismo municipio?");
    console.log(marcadores);
}

marcadoresMismoMunicipio();
initializeMap();

document.getElementById("route-profile").addEventListener("change", (event) => {
    console.log("Cambio de perfil de ruta");
    const selectedProfile = event.target.value;
    currentProfile = selectedProfile;

    setTimeout(() => {
        initializeMap();
    }, 500);

    setTimeout(() => {
        addItineraryMarkers();
    }, 1000);
});

document.addEventListener("DOMContentLoaded", () => {
    const routeProfileSelect = document.getElementById("route-profile");
    if (routeProfileSelect) {
        routeProfileSelect.value = "mapbox/driving-traffic"; // por defecto
    }
});

document.addEventListener("click", function (event) {
    const deleteButton = event.target.closest(".js-deleteevent-v2");
    if (deleteButton) {
        console.log("triggered deleteEvent listener in map-itinerary.js");
        const confirmed = deleteButton.getAttribute("data-confirmado");
        console.log(confirmed);
        if (confirmed == "false") {
            console.log("No confirmado");
            return;
        } else {
            console.log("Confirmado");
            // data-index empieza en 0.
            const index = parseInt(deleteButton.dataset.index);
            document
                .querySelectorAll(`#itineraryList .item-index-${index}`)
                .forEach((div) => div.remove());

            document
                .querySelectorAll("#itineraryList .number")
                .forEach((div, numberIndex) => {
                    // const currentIndex = parseInt(div.dataset.index);
                    // if (currentIndex > index) {
                    //     div.dataset.index = currentIndex;
                    //     div.textContent = currentIndex + 1;
                    // }
                    div.textContent = numberIndex + 1;
                    div.dataset.index = numberIndex;
                });
        }

        setTimeout(() => {
            initializeMap();
        }, 500);

        setTimeout(() => {
            addItineraryMarkers();
        }, 1000);
    }
});

function refreshMap(timeoutOnOff) {
    console.log("refreshMap()");
    if (timeoutOnOff) {
        setTimeout(() => {
            initializeMap();
        }, 500);

        setTimeout(() => {
            addItineraryMarkers();
        }, 1000);
    } else {
        initializeMap();
        addItineraryMarkers();
    }
}

function calculateAndDisplayTravelTime(route) {
    try {
        route.legs.forEach((leg, legIndex) => {
            // do nothing with the last leg
            // we will append a <div> with the time between #itineraryList .event elemtns
            let time = 0;
            leg.steps.forEach((step) => {
                time += step.duration;
            });

            let targetEvent = document.querySelectorAll(
                `#itineraryList .event`
            )[legIndex];

            let walkingIcon = targetEvent.querySelector(".walking-icon");
            let drivingIcon = targetEvent.querySelector(".driving-icon");

            if (legIndex === route.legs.length) {
                walkingIcon.classList.add("d-none");
                drivingIcon.classList.add("d-none");
                return;
            }

            console.log("profile", currentProfile);
            console.log("time", time);

            try {
                switch (currentProfile) {
                    case "mapbox/walking":
                        walkingIcon.classList.remove("d-none");
                        drivingIcon.classList.add("d-none");
                        break;
                    case "mapbox/driving-traffic":
                        walkingIcon.classList.add("d-none");
                        drivingIcon.classList.remove("d-none");
                        break;
                    default:
                        walkingIcon.classList.add("d-none");
                        drivingIcon.classList.add("d-none");
                        break;
                }
            } catch (e) {
                console.log("Error al cambiar el icono de transporte:", e);
            }


            console.log("target timeToNextEvent", targetEvent.querySelector(".timeToNextEvent"));

            targetEvent.querySelector(".timeToNextEvent").textContent =
                formatTime(time);
        });
        // let itineraryBody = document.querySelector(".itineraryBody");
        // let restaurantLink = document.querySelector(
        //     "#pauseTimeItinerayList-wrapper"
        // );
        // let lastEventInTheMorning = document.querySelector(".morning .event:last-child");
        // let lastEventTravelTime = lastEventInTheMorning.querySelector(".itemTimeItinerayList");

        // // insert the restaurant link in the last event of the morning, just before the travel time
        // lastEventInTheMorning.insertBefore(restaurantLink, lastEventTravelTime);



    } catch (e) {
        console.error("Error al añadir el tiempo a los eventos:", e);
    }
}

window.refreshMap = refreshMap;
